import { RadioButtonGroup } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { BasicParametersStore } from '../BasicParameters.store';

import { LogsIndex } from '../api/types';
import styles from '../BasicParameters.module.scss';

type Props = {
  store: BasicParametersStore;
};

export const LogsIndexSwitcher = observer(function LogsIndexSwitcher({ store }: Props) {
  const { t } = useTranslation();
  const { setLogsIndex, logsIndex } = store;

  const items = [
    {
      label: t('settings:time'),
      value: LogsIndex.TIME,
    },
    {
      label: t('settings:depth'),
      value: LogsIndex.DEPTH,
    },
  ];

  return (
    <RadioButtonGroup
      items={items}
      value={logsIndex}
      onChange={(v) => setLogsIndex(v)}
      className={styles.logIndexSwitcher}
    />
  );
});
